import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Search from 'pages/Parts/Search'
// import Pagination from 'pages/Parts/Pagination'

import { PGET } from 'helpers/api'

import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import Select from "react-select"

import { MultiSelect } from "react-multi-select-component"
import { formatMoney } from "helpers/helpers"



function Index() {
	const URL = '/services/admin/api/unconfirmed-payments-pageList'
	const { t } = useTranslation()
	const settings = useSelector(state => state.settings)

	const [pageCount, setPageCount] = useState(0)
	const [data, setData] = useState([])
	const today = new Date()
	const [year, setYear] = useState(String(today.getFullYear()))
	const [month, setMonth] = useState(String(today.getMonth() + 1))
	const [originalData, setOriginalData] = useState([])
	const [selectedDealers, setSelectedDealers] = useState([]);

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps



	useEffect(() => {
		filterByDealers(selectedDealers)
	}, [selectedDealers])


	const options = originalData.map(item => ({
		label: `${item.managerFirstName} ${item.managerLastName}`,
		value: `${item.managerFirstName} ${item.managerLastName}`
	}))
	async function getData() {
		const response = await PGET(`/services/admin/api/manager-pos-bonus?year=${year}&month=${month}`, {}, { loader: true })
		if (response) {
			console.log(response)
			setData(response.data)
			setOriginalData(response.data)
		}
	}
	const uniqueDealers = useMemo(() => {
		const dealerMap = new Map();
		originalData.forEach(item => {
			const fullName = `${item.managerFirstName} ${item.managerLastName}`;
			if (!dealerMap.has(fullName)) {
				dealerMap.set(fullName, { label: fullName, value: fullName });
			}
		});
		return Array.from(dealerMap.values());
	}, [originalData]);

	function filterByDealers(dealers) {
		if (!dealers || dealers.length === 0) {
			setData(originalData)
			return
		}
		const dealerNames = dealers.map(d => d.value)
		const filtered = originalData.filter(item =>
			dealerNames.includes(`${item.managerFirstName} ${item.managerLastName}`)
		)
		setData(filtered)
	}

	async function search(_, searchValue) {
		if (searchValue.trim() === '') {
			setData(originalData)
			return
		}

		const searchLower = searchValue.toLowerCase()
		const filtered = originalData.filter(item => {
			return Object.values(item).some(value =>
				(value ? String(value) : '').toLowerCase().includes(searchLower)
			)
		})
		setData(filtered)
		setPageCount(0)
	}

	function downloadExcel() {
		if (data.length === 0) return

		const header = [
			t('ID'),
			t('SALE_POINT_NAME'),
			t('Diler'),
			t('DATE_OF_START'),
			t('DATE_OF_END'),
			t('STATUS'),
			t('BONUS (%)'),
			t('Divident (UZS)')
		]

		const body = data.map(item => [
			item.posId,
			item.posName,
			`${item.managerFirstName} ${item.managerLastName}`,
			item.posCreatedDate,
			item.activeUntil,
			item.posActivated ? 'Активный' : 'Неактивный',
			((item.bonusAmount / item.posTariff) * 100).toFixed(2) || 0,
			item.bonusAmount
		])

		const ws = XLSX.utils.aoa_to_sheet([header, ...body])
		const wb = XLSX.utils.book_new()
		XLSX.utils.book_append_sheet(wb, ws, "Bonus Report")

		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" })
		const file = new Blob([excelBuffer], { type: "application/octet-stream" })
		saveAs(file, "bonus_report.xlsx")
	}


	function calculateColumnTotals(data) {
		if (data.length === 0) return {}
		const totals = {}
		Object.keys(data[0].monthlyAmounts).forEach(monthKey => {
			totals[monthKey] = data.reduce((sum, item) => {
				return sum + (item.monthlyAmounts[monthKey] || 0)
			}, 0)
		})
		return totals
	}

	function calculateBonusTotal(data) {
		return data.reduce((sum, item) => sum + (item.bonusAmount || 0), 0);
	}

	useEffect(() => {
		getData()
	}, [year, month]) // eslint-disable-line react-hooks/exhaustive-deps


	return (
		<>
			<style>
				{`
				.sticky-col-1 {
					position: sticky;
					left: 0;
					background: #fff;
					min-width: 100px;
				}
				.sticky-col-2 {
					position: sticky;
					left: 100px;
					background: #fff;
					min-width: 150px;
				}
				.sticky-col-3 {
					position: sticky;
					left: 250px;
					background: #fff;
					min-width: 150px;
				}

				.status-dot {
				display: inline-block;
				width: 10px;
				height: 10px;
				border-radius: 50%;
				margin-right: 6px;
			}

			.status-active {
				background-color: #2CA67A; /* yashil */
			}

			.status-inactive {
				background-color: #dc3545; /* qizil */
			}
				`}
			</style>

			<div className="card">
				<div className="card-body">
					<div className="d-flex mb-3 justify-content-between flex-wrap">
						<div className="d-flex flex-wrap align-items-center me-2" style={{ gap: '8px' }}>
							<Search url={URL} search={search} getData={getData} />

							<select
								className="form-control"
								style={{ width: '120px' }}
								value={year}
								onChange={(e) => setYear(e.target.value)}
							>
								{Array.from({ length: 11 }, (_, i) => 2025 + i).map(y => (
									<option key={y} value={y}>{y}</option>
								))}
							</select>

							<select
								className="form-control"
								style={{ width: '100px' }}
								value={month}
								onChange={(e) => setMonth(e.target.value)}
							>
								{Array.from({ length: 12 }, (_, i) => i + 1).map(m => (
									<option key={m} value={m}>{m}</option>
								))}
							</select>

							<div style={{ minWidth: 250, maxWidth: 250 }}>
								<MultiSelect
									options={uniqueDealers}
									value={selectedDealers}
									onChange={setSelectedDealers}
									labelledBy="Dilerlar"
									hasSelectAll={false}

									overrideStrings={{
										selectSomeItems: t('Dilerlar'),
										allItemsAreSelected: t('Barchasi tanlangan'),
										selectAll: t('Barchasini tanlash'),
										search: t('Qidirish...')
									}}
								/>
							</div>
						</div>

						<div>
							<button onClick={downloadExcel} className="btn btn-success">
								{t('Excelga yuklash')}
							</button>
						</div>

					</div>

					<div style={{ maxHeight: '550px', overflow: 'auto', position: 'relative' }}>
						<table className="table mb-0" style={{ maxHeight: '550px', overflow: 'auto', position: 'relative', whiteSpace: 'nowrap', borderCollapse: 'collapse', width: '100%' }}>
							<thead style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 3 }}>
								<tr>
									<th className="" style={{ backgroundColor: "white", zIndex: 99, }}>{t('ID')}</th>
									<th className="" style={{ backgroundColor: "white", zIndex: 99, }}>{t('SALE_POINT_NAME')}</th>
									<th className="" style={{ backgroundColor: "white", zIndex: 99, }}>{t('Diler')}</th>
									<th className="" style={{ backgroundColor: "white", zIndex: 99, }}>{t('DATE_OF_START')}</th>
									<th className="" style={{ backgroundColor: "white", zIndex: 99, }}>{t('DATE_OF_END')}</th>
									<th className="" style={{ backgroundColor: "white", zIndex: 99, }}>{t('STATUS')}</th>
									<th className="" style={{ backgroundColor: "white", zIndex: 99, }}>{t('BONUS')}</th>
									<th className="" style={{ backgroundColor: "white", zIndex: 99, }}>{t('Divident')}</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										<td className="1" style={{ backgroundColor: "white" }}>{item.posId}</td>
										<td className="2" style={{ backgroundColor: "white" }}>{item.posName}</td>
										<td className="3" style={{ backgroundColor: "white" }}>{item.managerFirstName + ' ' + item.managerLastName}</td>
										<td className="text-center">{item.posCreatedDate}</td>
										<td className="text-center">{item.activeUntil}</td>
										<td>
											<span className={`status-dot ${item.posActivated ? 'status-active' : 'status-inactive'}`}></span>
										</td>
										<td className="text-center">{(item.bonusAmount / item.posTariff) * 100 || 0}</td>
										<td className="text-center">{formatMoney(item.bonusAmount)}</td>
									</tr>
								))}
							</tbody>
							<tfoot>
								<tr style={{
									position: 'sticky',
									bottom: 0,
									background: '#fff',
									fontWeight: 'bold',
									borderTop: '2px solid #000',
									zIndex: 2,
								}}>
									<td><strong>{t('TOTAL')}</strong></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-center">{formatMoney(calculateBonusTotal(data))}</td>
								</tr>
							</tfoot>
						</table>
					</div>

				</div>
			</div>
		</>
	)
}

export default Index

function formatMonthLabel(key) {
	const [year, month] = key.split("-")
	const monthNames = [
		'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
		'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'
	]
	return `${monthNames[parseInt(month) - 1]} ${year.slice(2)}`
}
